import { auth, signOut } from "@/lib/auth";
import { redirect } from "next/navigation";
import Link from "next/link";

export default async function AdminLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const session = await auth();
  if (!session?.user || session.user.role !== "ADMIN") {
    redirect("/connexion");
  }

  return (
    <div className="flex-1 flex flex-col">
      <header className="border-b border-slate-200 bg-white">
        <div className="max-w-5xl mx-auto px-4 py-4 flex items-center justify-between">
          <div className="flex items-center gap-6">
            <span className="font-extrabold text-[#07008b]">Administration</span>
            <nav className="flex items-center gap-4 text-sm">
              <Link href="/admin" className="text-slate-500 hover:text-slate-800">
                Pharmacies
              </Link>
              <Link href="/admin/parametres" className="text-slate-500 hover:text-slate-800">
                Paramètres
              </Link>
            </nav>
          </div>
          <form
            action={async () => {
              "use server";
              await signOut({ redirectTo: "/" });
            }}
          >
            <button className="text-sm text-slate-500 hover:text-slate-800" type="submit">
              Se déconnecter
            </button>
          </form>
        </div>
      </header>
      <main className="flex-1 max-w-5xl w-full mx-auto px-4 py-8">{children}</main>
    </div>
  );
}
